<input
  #input
  type="file"
  id="{{ id }}"
  [accept]="accept"
  style="display: none"
  (change)="onSelectFile($event)"
  [multiple]="multiple"
  [disabled]="isDisabled"
  />

<div class="d-flex">
  @for (media of value; track media) {
    <div class="media-preview mx-2">
      @if (isImage(media)) {
        <div class="image-preview">
          <img [src]="media | getSecureImgSrc | async" />
        </div>
      }
      @if (!isImage(media)) {
        <div
          class="attachment-preview d-flex flex-column align-items-center justify-content-center px-1"
          >
          <span class="material-symbols-outlined"> add </span>
          <span class="title ellipsis w-100 text-center" [title]="media.filename">{{
            media.filename
          }}</span>
        </div>
      }
      <div class="actions">
        <ideapa-icon-button
          icon="cancel"
          title="elimina"
          cssClasses="text-dark"
          (clicked)="remove(media)"
        ></ideapa-icon-button>
        <ideapa-icon-button
          icon="download"
          title="download"
          cssClasses="text-dark"
          (clicked)="download(media)"
        ></ideapa-icon-button>
        @if (isImage(media)) {
          <ideapa-icon-button
            icon="preview"
            title="anteprima"
            cssClasses="text-dark"
            (clicked)="zoom(media, content)"
          ></ideapa-icon-button>
        }
      </div>
    </div>
  }

  @if ((multiple || !value || value.length === 0) && !isDisabled) {
    <div
      class="media-preview mx-2 d-flex align-items-center justify-content-center"
      >
      @if (!isLoading) {
        <label
          class="cursor-pointer"
          #fileInputLabel
          for="{{ id }}"
          disabled
          >
          <span class="material-symbols-outlined"> add </span>
        </label>
      }
    </div>
  }
</div>

<ng-template #content>
  <div class="modal-body text-center">
    @if (selectedAttachment) {
      <img
        [src]="selectedAttachment | getSecureImgSrc | async"
        />
    }
  </div>
</ng-template>
